// i18n keys of the multi-tenant work package "people" (en / zh / th). ⛔ Fill all three: an empty th value falls back to English.
export const en: Record<string, string> = {
  people_names_title: 'Names & greetings',
  people_names_hint: 'What each login is also called and how emails greet them. Aliases are the other names a person goes by — a job comment that says one of them pings that person, and a staff folder may carry one. The greeting opens the emails a role sends them (left empty: the nickname, else the name).',
  people_col_login: 'Login',
  people_col_aliases: 'Also called',
  people_col_greeting: 'Greeting',
  people_aliases_ph: 'e.g. Sam, Sammy',
  people_greeting_ph: 'Empty = {{name}}',
  people_greets_as: 'Emails say: “{{name}}”',
  people_show_disabled: 'Show disabled logins ({{n}})',
  people_save: 'Save',
  people_saved: 'Saved',
  people_none: 'No staff logins.',
  people_mailboxes_title: 'Personal mailboxes',
  people_mailboxes_hint: 'An address such as marketing@ or info@ is treated as a shared mailbox: no Snooze, no Schedule send. Tick the ones that are really one person’s own mailbox. A mailbox shared with colleagues stays shared whatever is ticked here.',
  people_mailbox_personal: 'One person’s own mailbox',
  people_mailboxes_none: 'No connected mailbox has a shared-looking address.',
  people_or: ' or ',
  people_roles_note: 'Who a job can be assigned to, who receives the Petty Cash reminders and who may clear a do-not-email flag are roles — see Admin → Roles.',
};
export const zh: Record<string, string> = {
  people_names_title: '称呼与问候',
  people_names_hint: '每个登录账号的别名，以及邮件如何称呼此人。别名是此人的其他叫法 —— 工作评论里写到其中一个就会提醒到此人，员工文件夹也可以用别名命名。问候语用于角色邮件的开头（留空：用昵称，再无则用姓名）。',
  people_col_login: '登录账号',
  people_col_aliases: '别名',
  people_col_greeting: '问候语',
  people_aliases_ph: '例如 Sam, Sammy',
  people_greeting_ph: '留空 = {{name}}',
  people_greets_as: '邮件称呼：“{{name}}”',
  people_show_disabled: '显示已停用的账号（{{n}}）',
  people_save: '保存',
  people_saved: '已保存',
  people_none: '没有员工账号。',
  people_mailboxes_title: '个人邮箱',
  people_mailboxes_hint: '像 marketing@、info@ 这样的地址会被当作共享邮箱：不能稍后提醒，也不能定时发送。勾选其中确实属于某一个人的邮箱。已共享给同事的邮箱，无论这里是否勾选都仍算共享。',
  people_mailbox_personal: '属于某一个人的邮箱',
  people_mailboxes_none: '已连接的邮箱中没有看起来像共享地址的。',
  people_or: ' 或 ',
  people_roles_note: '工作可以指派给谁、零用金提醒发给谁、谁可以清除“禁止外发”标记，都是角色 —— 见 管理 → 角色。',
};
export const th: Record<string, string> = {
  people_names_title: 'ชื่อเรียกและคำทักทาย',
  people_names_hint: 'ชื่ออื่นของแต่ละบัญชีผู้ใช้ และคำที่อีเมลใช้ทักทาย ชื่ออื่นคือชื่อที่คนนั้นถูกเรียก — ความเห็นในงานที่เอ่ยชื่อใดชื่อหนึ่งจะแจ้งเตือนคนนั้น และโฟลเดอร์พนักงานอาจใช้ชื่อนี้ คำทักทายใช้ขึ้นต้นอีเมลที่บทบาทส่งถึงเขา (เว้นว่าง: ใช้ชื่อเล่น ถ้าไม่มีใช้ชื่อ)',
  people_col_login: 'บัญชีผู้ใช้',
  people_col_aliases: 'ชื่ออื่น',
  people_col_greeting: 'คำทักทาย',
  people_aliases_ph: 'เช่น Sam, Sammy',
  people_greeting_ph: 'เว้นว่าง = {{name}}',
  people_greets_as: 'อีเมลจะเรียกว่า “{{name}}”',
  people_show_disabled: 'แสดงบัญชีที่ปิดใช้งาน ({{n}})',
  people_save: 'บันทึก',
  people_saved: 'บันทึกแล้ว',
  people_none: 'ไม่มีบัญชีพนักงาน',
  people_mailboxes_title: 'กล่องอีเมลส่วนตัว',
  people_mailboxes_hint: 'ที่อยู่อย่าง marketing@ หรือ info@ ถือเป็นกล่องอีเมลส่วนกลาง: เลื่อนเตือน (Snooze) และตั้งเวลาส่งไม่ได้ ให้ทำเครื่องหมายกล่องที่เป็นของคนคนเดียวจริง ๆ กล่องที่แชร์ให้เพื่อนร่วมงานแล้วยังถือเป็นกล่องส่วนกลางไม่ว่าจะทำเครื่องหมายหรือไม่',
  people_mailbox_personal: 'กล่องอีเมลของคนคนเดียว',
  people_mailboxes_none: 'ไม่มีกล่องอีเมลที่เชื่อมต่อซึ่งมีที่อยู่แบบส่วนกลาง',
  people_or: ' หรือ ',
  people_roles_note: 'ใครรับงานได้ ใครได้รับการแจ้งเตือนเงินสดย่อย และใครล้างธง “ห้ามส่งอีเมล” ได้ เป็นบทบาท — ดูที่ ผู้ดูแล → บทบาท',
};
